module.exports = __webpack_public_path__ + "img/success.16f2aa68.svg";